import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5bece7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "add-stories" }
const _hoisted_3 = { class: "add-stories-banner" }
const _hoisted_4 = { class: "add-stories-banner__title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "add-stories__footer-text" }

import { IonContent, IonPage } from '@ionic/vue';

import BaseButton from '@/components/BaseButton.vue';
import TheHeader from '@/components/TheHeader.vue';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddStoriesPage',
  setup(__props) {

const { t } = useInternalization();

function handleGoToGoogleForm() {
  window.open('mailto:support@feelyou.com', '_blank');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(TheHeader),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('shareYourStory')), 1),
                _createElementVNode("div", {
                  class: "add-stories-banner__message",
                  innerHTML: _unref(t)('messages.addStoriesBannerMessageHTML')
                }, null, 8, _hoisted_5)
              ]),
              _createVNode(BaseButton, { onClick: handleGoToGoogleForm }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('emailUs')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('addStoriesFooterText')), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})